module.exports = __webpack_public_path__ + "static/media/06_MINS-2.3-ES-10 1.1178009d.svg";